<lib-creating-dummy-form
  *ngIf="virtualContainerDetails$ | async as details"
  [reasonsOptions]="details.virtualContainerReasons"
  [dummy]="dummyPallet"
  [articleOptions]="this.getAlternativeArticleOptions()"
  (createNewDummyEvent)="addNewVirtualInputContainer($event)"
  (updateDummyInfoEvent)="updateVirtualContainerReasonInfo($event)"
  [inputPlaceholder]="'MOUNTING.PLEASE_ENTER_ID' | translate"
  [mountedLabel]="'MOUNTING.MOUNTED' | translate"
  [reasonsLabel]="'MOUNTING.REASON' | translate"
  [articleLabel]="'MOUNTING.ARTICLE' | translate"
  [infoLabel]="'MOUNTING.INFO' | translate"
  [mountButtonLabel]="'MOUNTING.MOUNT'"
  [updateButtonLabel]="'MOUNTING.SAVE'"
  [reasonsDefaultValue]="'DROPDOWN_DEFAULT_LABEL' | translate"
  [articleDefaultValue]="'DROPDOWN_DEFAULT_LABEL' | translate"
  [loadingTopic]="LOADING_TOPIC"
  [askForProductionOrder]="details.askForProductionOrder"
  [productionOrderCodeLabel]="'MOUNTING.PRODUCTIONORDERCODE_LABEL' | translate"
></lib-creating-dummy-form>
